import { adminUsersAdapter, UsersPage } from '@pa/staff'
import { useMemo } from 'react'

/**
 * S-04 Users tab (UserFlows S-04: "the same table and actions as C-13 for this clinic") with S-05 Add clinic user
 * (the C-13a dialog, role default Admin) → C-13b: the shared `users` feature over the admin adapter (#47–#51).
 */
export function UsersTab({ clinicId }: { clinicId: string }) {
  const adapter = useMemo(() => adminUsersAdapter(clinicId), [clinicId])
  return <UsersPage adapter={adapter} layout="tab" />
}
